// loadTappayScript.js
'use strict';
import env from '../resource/env.js';
import loadScriptTag from '../resource/loadScriptTag.js';

const isProd = 'production' === env.NODE_ENV;
const tappayAppId = +env.TAPPAY_APP_ID;
const tappayAppKey = env.TAPPAY_APP_KEY;

const loadTappayScript = () =>
  new Promise((resolve, reject) =>
    loadScriptTag({
      id: 'tappay-script',
      src: 'https://js.tappaysdk.com/tpdirect/v5.8.0',
      onError: reject,
      onLoad: result => {
        window.TPDirect.setupSDK(
          tappayAppId,
          tappayAppKey,
          isProd ? 'production' : 'sandbox'
        );
        return resolve(result);
      },
    })
  );

export default loadTappayScript;
